const SkeletonBlock = ({
  type,
  height,
  columns,
  items,
  titleWidth,
  subtitleWidth,
  count,
  buttonCount,
  imageHeight,
}) => {
  switch (type) {
    case 'banner':
      return <div style={{ height, backgroundColor: '#f0f0f0', marginBottom: '20px' }} />;
    case 'hero':
      return (
        <div
          style={{
            height,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px',
            backgroundColor: '#f9f9f9',
          }}
        >
          <div style={{ flex: 1 }}>
            <div style={{ width: titleWidth, height: '40px', backgroundColor: '#e0e0e0', marginBottom: '20px' }} />
            <div
              style={{ width: subtitleWidth, height: '20px', backgroundColor: '#e0e0e0', marginBottom: '30px' }}
            />
            <div style={{ display: 'flex' }}>
              {[...Array(buttonCount)].map((_, i) => (
                <div
                  key={i}
                  style={{ width: '120px', height: '40px', backgroundColor: '#e0e0e0', marginRight: '10px' }}
                />
              ))}
            </div>
          </div>
          <div style={{ width: '50%', height: imageHeight, backgroundColor: '#e0e0e0' }} />
        </div>
      );
    case 'grid':
      return (
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: '20px' }}>
          {[...Array(items)].map((_, i) => (
            <div key={i} style={{ height: '200px', backgroundColor: '#f0f0f0' }} />
          ))}
        </div>
      );
    case 'filters':
      return <div style={{ height, backgroundColor: '#f0f0f0', marginBottom: '20px' }} />;
    case 'header':
      return <div style={{ height, backgroundColor: '#f0f0f0', marginBottom: '20px' }} />;
    case 'tabs':
      return (
        <div style={{ display: 'flex', marginBottom: '20px' }}>
          {[...Array(count)].map((_, i) => (
            <div
              key={i}
              style={{ width: '100px', height: '40px', backgroundColor: '#f0f0f0', marginRight: '10px' }}
            />
          ))}
        </div>
      );
    case 'content':
      return <div style={{ height, backgroundColor: '#f0f0f0' }} />;
    default:
      return null;
  }
};

export const DynamicSkeleton = ({ layout, contentBlocks }) => {
  const renderLayout = () => {
    switch (layout) {
      case 'sidebar':
        return (
          <div style={{ display: 'flex' }}>
            <div style={{ width: '250px', backgroundColor: '#f0f0f0', marginRight: '20px' }} />
            <div style={{ flex: 1 }}>
              {contentBlocks.map((block, index) => (
                <SkeletonBlock key={index} {...block} />
              ))}
            </div>
          </div>
        );
      case 'default':
      default:
        return (
          <div>
            {contentBlocks.map((block, index) => (
              <SkeletonBlock key={index} {...block} />
            ))}
          </div>
        );
    }
  };

  return <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>{renderLayout()}</div>;
};
